import React, { useContext } from "react";
import { MovieContext } from "../../app-context/MovieContext";
import Layout from "../Layout";
import MovieOverlay from "./MovieModel";
import { NavLink } from "react-router-dom";

const Watchlist = () => {
  const { watchlist, removeFromWatchlist } = useContext(MovieContext);
  return (
    <Layout>
      <div className="p-4">
        <h2 className="text-xl mb-4">My Watchlist</h2>
        {watchlist.length === 0 ? (
          <>
            <p>No movies in your watchlist.</p>
            <NavLink to="/" style={{ textDecoration: "underline" }}>
              Search Movies
            </NavLink>
          </>
        ) : (
          watchlist.map((movie) => (
            <div
              key={movie.imdbID}
              className="p-2 border flex flex-row justify-between border-gray-300 rounded mb-2"
            >
              <div>
                <img
                  src={movie.Poster}
                  alt={movie.Title}
                  className="w-16 h-16 object-cover inline-block mr-2"
                />
                <h3 className="inline-block">
                  {movie.Title} ({movie.Year})
                </h3>
              </div>
              <div className="flex gap-4 items-center">
                <button
                  onClick={() => removeFromWatchlist(movie.imdbID)}
                  className="ml-2 p-1 bg-red-500 text-white rounded"
                >
                  Remove
                </button>
                <MovieOverlay movie={movie} />
              </div>
            </div>
          ))
        )}
      </div>
    </Layout>
  );
};

export default Watchlist;
